import axios from 'axios'
import router from '../router'

// 根据环境确定baseURL
// 开发环境使用相对路径，通过代理解决跨域问题
// 生产环境使用环境变量配置的完整URL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境使用空字符串，让请求走代理
    return ''
  } else {
    // 生产环境使用配置的API地址
    return process.env.VUE_APP_API_BASE_URL || 'https://mail.sainbainu.com'
  }
}

// 创建axios实例
const request = axios.create({
  baseURL: getBaseURL(),
  timeout: 60000 // 60秒超时
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 统一POST为JSON（排除FormData）避免后端JSON解析错误
    if ((config.method || '').toLowerCase() === 'post' && config.data && !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json'
      if (typeof config.data !== 'string') {
        try {
          config.data = JSON.stringify(config.data)
        } catch (_) {
          // 兜底：保持原样，避免中断请求
        }
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 检查API返回的业务状态码
    const data = response.data
    
    // 如果业务状态码是401，说明token无效或已过期
    if (data.code === 401) {
      console.log('Token无效或已过期，跳转到登录页面')
      // 清理本地存储
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user_info')
      // 跳转到登录页
      router.push('/login')
      // 抛出错误，阻止后续处理
      return Promise.reject(new Error('Token无效或已过期'))
    }
    
    // 检查业务状态码，如果不是0（成功），则抛出错误
    if (data.code !== 0) {
      console.error('API业务错误:', data)
      // 创建一个包含错误信息的Error对象
      const error = new Error(data.msg || '请求失败')
      error.code = data.code
      error.data = data
      return Promise.reject(error)
    }
    
    // 业务状态码为0时，返回响应数据
    return data
  },
  error => {
    console.error('请求错误:', error)
    
    // 检查是否是网络连接错误（服务器未启动）
    if (error.code === 'ECONNREFUSED' || error.message.includes('ECONNREFUSED') || 
        error.message.includes('Network Error') || !error.response) {
      console.error('后端服务器连接失败，请检查服务器是否启动')
      // 返回一个模拟的错误响应，保持与后端API格式一致
      return Promise.reject({
        code: -1,
        msg: '服务器开小差了，请稍后再试',
        data: null
      })
    }
    
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // HTTP 401 未授权，直接跳转到登录页
          console.log('HTTP 401 未授权，跳转到登录页面')
          // 清理本地存储
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_user_info')
          // 跳转到登录页
          router.push('/login')
          break
        case 403:
          console.error('没有权限访问')
          break
        case 500:
          console.error('服务器错误')
          break
        default:
          console.error(error.response.data?.message || '请求失败')
      }
    } else {
      console.error('网络错误或服务器无响应')
    }
    
    return Promise.reject(error)
  }
)

export default request